jQuery( function($) {

    $('.js-miembro').each(function () {
        var $this = $(this);
        var $top = $this.find('.js-miembro__top');
        var $text = $this.find('.js-miembro__text');
        var $phrase = $this.find('.js-miembro__phrase');

        $top.hover(
            function () {
                console.log('enter');
                $text.stop().slideReplace($phrase);
                },
            function () {
                console.log('leave');
                $phrase.stop().slideReplace($text);
            }
        );
    });

});
